import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useActions } from 'utils/hooks';
import Select from 'common/components/form/inputs/Select';
import * as listActions from 'store/lists/actions';

const IndexTypeSelector = ({ filter, value, onChange, isMulti, label, placeholder }) => {
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const marketIndexTypes = useSelector(state => state.lists['market-index-types']);

  useEffect(() => {
    if (!marketIndexTypes.length) fetchListOptions('market-index-types');
  }, []);

  return (
    <Select
      label={label}
      placeholder={placeholder ? placeholder : 'Select value'}
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={marketIndexTypes.options}
      isMulti={isMulti}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? (isMulti ? selected : selected) : ''
        })
      }
      isClearable
    />
  );
};

export default IndexTypeSelector;
